import { FC, memo, useState } from 'react';
import { Box, Circle } from '@bridebook/ui';
import { NetworkProps } from './network.types';

interface IProps extends NetworkProps {
  isMobile: boolean;
  isTablet: boolean;
}

const NetworkComponent: FC<IProps> = ({ icon, iconWidth, color, isMobile, isTablet }) => {
  const Icon = icon;

  const [hover, setHover] = useState(false);
  const onMouseEnter = () => setHover(true);
  const onMouseLeave = () => setHover(false);

  const props = isMobile || isTablet ? { onMouseEnter, onMouseLeave } : {};

  return (
    <Box {...props}>
      <Circle size={30} borderWidth={1} borderColor={color} color={hover ? color : 'white'}>
        <Icon width={iconWidth} color={hover ? 'white' : color} />
      </Circle>
    </Box>
  );
};

export const Network = memo(NetworkComponent);
